module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba-funabashi-point2-3@3x-6f8eeddfd6e4d8a1c50958df394a7139.webp";